import React from "react";

const SignosMedica = ({signos, onChange, errors, disabled}) => {
    const onChangeProperty = (prop, value) => {
        onChange({
            ...signos,
            [prop]: value,
        })
    };

    return <>
        <div className="col-md-12">
            <div className="form-group">
                <label>Temperatura *</label>
                <input 
                    type="number"
                    step={0.01}
                    value={signos.temperatura ?? ''}
                    onChange={e => onChangeProperty('temperatura', e.target.value)}
                    className="form-control" 
                    name="temperatura"
                    disabled={disabled}
                />
                {errors['signos.temperatura'] && (
                    <small className='help-blockParams form-Text'>
                        {errors['signos.temperatura'][0]}
                    </small>
                )}
            </div>
        </div>

        <div className="col-md-12">
            <div className="form-group">
                <label>Presión Arterial *</label>
                <input 
                    type="text"
                    value={signos.presion  ?? ''}
                    onChange={e => onChangeProperty('presion', e.target.value)}
                    className="form-control" 
                    name="presion"
                    disabled={disabled}
                />
                {errors['signos.presion'] && (
                    <small className='help-blockParams form-Text'>
                        {errors['signos.presion'][0]}
                    </small>
                )}
            </div>
        </div>

        <div className="col-md-12">
            <div className="form-group">
                <label>Frecuencia Cardíaca *</label>
                <input 
                    type="number"
                    step={1}
                    value={signos.frecuencia  ?? ''}
                    onChange={e => onChangeProperty('frecuencia', e.target.value)}
                    className="form-control" 
                    name="frecuencia"
                    disabled={disabled}
                />
                {errors['signos.frecuencia'] && (
                    <small className='help-blockParams form-Text'>
                        {errors['signos.frecuencia'][0]}
                    </small>
                )}
            </div>
        </div>
    </>;
};

export default SignosMedica;